import axios, { CancelTokenSource } from 'axios';
import Input from 'components/final-form/Input';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import _ from 'lodash';
import React, { Component } from 'react';
import { Field } from 'react-final-form';
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Accordion, Grid, Header, Icon } from 'semantic-ui-react';
import styled from 'styled-components';
import { BillStatus } from 'ts-types/api.enums';
import { BillingDataDto } from 'ts-types/api.types';
import { ensureOnlyNumericInput } from 'utils/filterUtils';
import { composeValidators, mustBeNumber, mustBePositiveNumber } from 'utils/validatorUtils';

const InstallmentsDisabled = styled.span`
  padding-left: 0.85rem;
  color: #b58105;
`;

const InstallmentsDisabledIcon = styled.span`
  padding-right: 0.275rem;
`;

const InstallmentsDisabledText = styled.span``;

interface Props extends MessageSourceProps {
  billingData: BillingDataDto
}

interface State {
  activeIndex: number,
  cancelTokenSource: CancelTokenSource
}

class BillDataSegment extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      activeIndex: -1,
      cancelTokenSource
    }
  }

  componentWillUnmount(): void {

    const {cancelTokenSource} = this.state;
    cancelTokenSource.cancel('Operation canceled by user');
  }

  toggleAccordion = () => {
    this.setState(({activeIndex}: State) => ({
      activeIndex: activeIndex == 0 ? -1 : 0
    }));
  };

  render(): React.ReactNode {

    const {billingData, getMessage} = this.props;
    const {activeIndex} = this.state;

    const installmentsDisabled =
        billingData && !_.isNil(billingData.guarantorId) && billingData.isTarmedTariff;

    return (
        <React.Fragment>
          <Accordion fluid>
            <Accordion.Title active={activeIndex === 0} index={0} onClick={this.toggleAccordion}>
              <Header><Icon name="dropdown"/>{getMessage("bill.data")}</Header>
            </Accordion.Title>
            <Accordion.Content active={activeIndex === 0}>
              <PraxFormGrid>
                <Grid.Row>
                  <Grid.Column verticalAlign="middle">
                    <Header>{getMessage("bill.amountHeader")}</Header>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} verticalAlign="middle">
                    {getMessage("bill.amount")}:
                  </Grid.Column>
                  <Grid.Column width={6} verticalAlign="middle">
                    <Field
                        name="billAmount"
                        component={Input}
                        validate={composeValidators(mustBeNumber, mustBePositiveNumber)}
                        fluid
                    />
                  </Grid.Column>
                  <Grid.Column width={3} verticalAlign="middle">
                    {getMessage("bill.advancePayment")}:
                  </Grid.Column>
                  <Grid.Column width={5} verticalAlign="middle">
                    <Field
                        name="billAdvanceAmount"
                        component={Input}
                        validate={composeValidators(mustBeNumber, mustBePositiveNumber)}
                        disabled={billingData.treatmentBillStatus != BillStatus.OPEN}
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} verticalAlign="middle">
                    <Header>{getMessage("bill.installments")}</Header>
                  </Grid.Column>
                  {
                      installmentsDisabled &&
                      <Grid.Column width={14} verticalAlign="middle" style={{marginTop: "-4px"}}>
                        <InstallmentsDisabled>
                          <InstallmentsDisabledIcon>
                            <Icon name="exclamation triangle" aria-hidden="true"/>
                          </InstallmentsDisabledIcon>
                          <InstallmentsDisabledText>
                            {getMessage("bill.installmentsDisabled")}
                          </InstallmentsDisabledText>
                        </InstallmentsDisabled>
                      </Grid.Column>
                  }
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={2} verticalAlign="middle">
                    {getMessage("quantity")}:
                  </Grid.Column>
                  <Grid.Column width={6} verticalAlign="middle">
                    <Field
                        name="installmentQuantity"
                        component={Input}
                        onKeyDown={ensureOnlyNumericInput}
                        disabled={installmentsDisabled}
                        fluid
                    />
                  </Grid.Column>
                  <Grid.Column width={2} verticalAlign="middle">
                    {getMessage("bill.days")}:
                  </Grid.Column>
                  <Grid.Column width={6} verticalAlign="middle">
                    <Field
                        name="installmentDays"
                        component={Input}
                        onKeyDown={ensureOnlyNumericInput}
                        disabled={installmentsDisabled}
                        fluid
                    />
                  </Grid.Column>
                </Grid.Row>
              </PraxFormGrid>
            </Accordion.Content>
          </Accordion>
        </React.Fragment>
    );
  }
}

export default withMessages(BillDataSegment);
